
  
 <div>
 
<div class="page">

  <div style="overflow: hidden;width: 100%;">
    <div style="float:left;width:70%;">    
      <h2 class="page-title">Mes GLN</h2>
      <p>Retrouvez ici la liste de vos entités et lieux.</p>
    </div>
    <div style="float:left;width:30%;padding-bottom: 1%;padding-top: 1%;"> 
      <mat-card [ngClass]="isWarning ? 'mat-card-warning' : 'mat-card-normal'">
        <mat-card-content>
        <div style="float:left;">
          <p class="spinner-title">GLN utilisés</p>
        </div>
        <div style="float: right;padding-right: 2%;" [ngClass]="isWarning ? 'mat-color-warning spinner-container container' : 'mat-color-normal spinner-container container'" >   
          <div class="content" [ngStyle]="{'padding-top': (isWarning) ? '30%' : '40%'}">            
              <div [ngClass]="isWarning ? 'mat-color-span-normal-warning' : 'mat-color-span-normal'">
                {{ formatGlnCount(this.totalAuthorizedUsedCode) }}
              </div>          
              <div [ngClass]="isWarning ? 'mat-color-span-small-warning' : 'mat-color-span-small'">
                sur {{ formatGlnCount(this.totalAuthorizedCodeRange) }}
              </div>       
            </div>
            <div class="overlay">            
                <mat-progress-spinner [ngClass]="isWarning ? 'mat-progress-spinner-warning' : 'mat-progress-spinner-normal'" [strokeWidth]="9" [diameter]="127" [mode]="mode" [value]="value"></mat-progress-spinner>
               
                <div class="new-code-order-link" *ngIf="isWarning">
                  <a href="{{this.urlNewCodeOrder}}" style="text-decoration: none;" target="_blank">Commander un nouveau préfixe <i class="bi bi-arrow-right"></i></a>
                </div>           
              </div>
        </div>
      </mat-card-content> 
  
      </mat-card>
      
    </div>
  </div>




  
  <gs1-table *ngIf="columns; else loader" [data]="dataTable" [columns]="columns" [pageSize]="10" [isLoading]="loading"
      [searchPlaceholder]="'Rechercher par nom ou code GLN'" [searchPosition]="'left'" [noDataMessage]="'Aucun résultat trouvé'"
      [sortBy]="'isMain'" [direction]="'desc'" [searchable]="true" [searchColumns]="['name','gln']"
      (contentClicked)="contentClicked($event)" [rowClickable]="true" (rowClicked)="rowClicked($event)" (pageChangeEvent)="saveState()" [sortingDataAccessor]="sortingDataAccessor">
    <button *ngIf="admin" gs1Button [thin]="true" [color]="'blue'" routerLink="/mes-gln/importer">
      <i class="bi bi-cloud-upload"></i>Importer
    </button>
    <button gs1Button [thin]="true" [color]="'blue'" [disabled]="dataTable.length < 1" [pending]="exportLoading" (click)="export()">
      <i class="bi bi-box-arrow-down"></i>Exporter
    </button>
    <button *ngIf="admin" gs1Button [thin]="true" routerLink="/mes-gln/creer">
      <i class="bi bi-plus-circle"></i>Nouveau
    </button>
  </gs1-table>
  <ng-template #loader>
    <div class="spinner-wrapper">
      <div gs1Spinner [size]="'40px'" [big]="true"></div>
    </div>
  </ng-template>
</div>
</div>
